// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"MenuItem_menuItem__Csvkd","menuImage":"MenuItem_menuImage__jG_Y7","menuLink":"MenuItem_menuLink__FFERK","lastenImg":"MenuItem_lastenImg__RBJAA"};